<template>
  <div class="falcon-chart" :class="locked? 'locked': ''" ref="chart">

  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS, FONT_FAMILY} from "./chartColors";
import {formatDollars, formatDollarsNoZeros, formatMillionsDollars} from "../../moneyUtils";
import echarts from "echarts";
import {xAxisStyle} from "@/shared/components/charts/charts-utils";

export default {
  name: 'checklistGraph',
  data() {
    return {
      graphData: this.data,
    }
  },
  props: ['data', 'locked', 'width'],
  mounted() {
    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg'
    });

    // specify chart configuration item and data
    var option = {
      grid: {
        // containLabel: true
      },
      legend: {
        show: true,
        orient: 'vertical',
        right: 0,
        data: [{
          name: 'Your Valuation',
          icon: 'circle'
        }, {
          name: 'Max valuation for similar startups',
          icon: 'circle'
        }, ]
      },
      tooltip: {
        show: true,
        trigger: 'axis'
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      barWidth: 70,
      xAxis: {
        axisLine: {
          lineStyle: {
            color: '#899094'
          },
        },
        axisTick: {
          show: false,

        },
        nameRotate: 90,
        axisLabel: {
          fontSize: 12
        },
        tickOptions: {showGridLine: false},
        type: 'category',
        data: [xAxisStyle(formatDollarsNoZeros(this.graphData.management_team) + '\nManagement\nteam'),
          xAxisStyle(formatDollarsNoZeros(this.graphData.idea_quality)  + '\nIdea\nQuality'),
           xAxisStyle(formatDollarsNoZeros(this.graphData.technology_product) + '\nProduct\n& Technology'),
           xAxisStyle(formatDollarsNoZeros(this.graphData.strategic_relationships)  + '\nStrategic\nRelationships'),
           xAxisStyle(formatDollarsNoZeros(this.graphData.operating_stage) + '\nOperating\nStage')]
      },
      yAxis: {
        axisLabel: {
          show: false,
          color: '#899094',
          formatter: formatMillionsDollars
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#fff'

          },
        },
        splitLine: {
          lineStyle: {
            color: ['#E3E9EA'],
          }
        },
      },
      series: [

        {
          type: 'bar',
          stack: 'stack1',
          name: 'Your Valuation',
          data: [
            this.graphData.management_team,
            this.graphData.idea_quality,
            this.graphData.technology_product,
            this.graphData.strategic_relationships,
            this.graphData.operating_stage,
          ],
          itemStyle: {
            color: CHART_COLORS.MAIN,
            // barBorderRadius: [5, 5, 0, 0]
          },
          tooltip: {
            formatter: function (params, ticket, callback) {
              return formatDollars(params['value'])
            },
          },
        },
        {
          type: 'bar',
          stack: 'stack1',
          name: 'Max valuation for similar startups',
          data: [
            this.graphData.management_team_max,
            this.graphData.idea_quality_max,
            this.graphData.technology_product_max,
            this.graphData.strategic_relationships_max,
            this.graphData.operating_stage_max,
          ],
          itemStyle: {
            color: '#E3E9EA',
            barBorderRadius: [5, 5, 0, 0]
          },
          emphasis: {
            itemStyle: {
              borderWidth: 1,
              // shadowBlur: 1,
              shadowColor: '#000',
              borderColor: '#eee',
            }
          },
          tooltip: {
            formatter: function (params, ticket, callback) {
              return formatDollars(params['value'])
            },
          },
        }
      ]
    };

    myChart.setOption(option);
  },
  methods: {},
  computed: {},
}
</script>

<style scoped>
.falcon-chart {
  width: 100%;
  height: 400px;
}
</style>
